
const util = require('util');

const _ = require('lodash');

const bytes = require('bytes');

const vb = require('../definition');

const {
	unwrap,
} = require('../util');

vb.everyFileMaxSize = maxSize => {
	return {
		validator: v => {
			const maxSizeValue = bytes.parse(unwrap(maxSize));
			return _.every(v, f => {
				const file = unwrap(f);
				const fileSize = file && file.Size();
				return !fileSize
					|| (fileSize <= maxSizeValue);
			});
		},
		message: () => {
			const maxSizeRepr = bytes(bytes.parse(unwrap(maxSize)));
			return util.format('размер файла не может превышать %s', maxSizeRepr);
		},
	};
};
